"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGranteePossibilities = exports.getEffectivePermission = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var types_1 = require("../types");
var locales_1 = require("../../../../locales");
var allPermissionsSorted = ["EDIT", "SHARE", "VIEW"];
exports.getEffectivePermission = function (permissions, inheritedPermissions, isSharedObjectLocked) {
    var allUserPermissions = tslib_1.__spread(permissions, inheritedPermissions);
    var effectivePermission = allPermissionsSorted.find(function (permission) {
        return allUserPermissions.includes(permission);
    });
    ts_invariant_1.default(effectivePermission, "Provided item permissions are incomplete or invalid");
    if (isSharedObjectLocked && effectivePermission === "EDIT") {
        return "SHARE";
    }
    return effectivePermission;
};
var disableWithTooltip = function (possibility, tooltip) {
    possibility.enabled = false;
    possibility.tooltip = tooltip;
};
var getPermissionTypeItems = function (grantee, currentUserPermissions, isSharedObjectLocked) {
    return allPermissionsSorted.map(function (permission, permissionIndex) {
        var item = {
            id: permission,
            enabled: true,
            tooltip: "",
            hidden: false,
        };
        // don't allow setting permissions higher that the current user
        if ((permission === "EDIT" && !currentUserPermissions.canEditAffectedObject) ||
            (permission === "SHARE" && !currentUserPermissions.canShareAffectedObject) ||
            !currentUserPermissions.canViewAffectedObject) {
            disableWithTooltip(item, "shareDialog.share.granular.grantee.tooltip.cannotGrantHigher");
        }
        // hide Edit & share on inherited object
        if (permission === "EDIT" && isSharedObjectLocked) {
            item.hidden = true;
        }
        // don't allow setting permission lower that permission obtained indirectly
        grantee.inheritedPermissions.forEach(function (inheritedPermission) {
            var inheritedPermissionIndex = allPermissionsSorted.indexOf(inheritedPermission);
            if (permissionIndex > inheritedPermissionIndex) {
                disableWithTooltip(item, types_1.isGranularGranteeUser(grantee)
                    ? locales_1.granularPermissionMessageTooltips.cannotGrantLowerForUser.id
                    : locales_1.granularPermissionMessageTooltips.cannotGrantLowerForGroup.id);
            }
        });
        return item;
    });
};
exports.getGranteePossibilities = function (grantee, currentUserPermissions, isSharedObjectLocked) {
    var granteeEffectivePermission = exports.getEffectivePermission(grantee.permissions, grantee.inheritedPermissions, isSharedObjectLocked);
    // the "Remove" option state
    var remove = {
        enabled: true,
        tooltip: "",
    };
    // state of the whole permissions selection dropdown
    var change = {
        enabled: true,
        tooltip: "",
    };
    //state of the permissions selection dropdown items
    var permissionTypeItems = getPermissionTypeItems(grantee, currentUserPermissions, isSharedObjectLocked);
    // cannot change or remove permissions of a grantee that has higher permission than the current user
    if ((granteeEffectivePermission === "EDIT" && !currentUserPermissions.canEditAffectedObject) ||
        (granteeEffectivePermission === "SHARE" && !currentUserPermissions.canShareAffectedObject)) {
        var tooltipId = types_1.isGranularGranteeUser(grantee)
            ? locales_1.granularPermissionMessageTooltips.cannotChangeHigherForUser.id
            : locales_1.granularPermissionMessageTooltips.cannotChangeHigherForGroup.id;
        disableWithTooltip(change, tooltipId);
        disableWithTooltip(remove, tooltipId);
    }
    // cannot remove permission that is defined on the object in parent workspace
    if (grantee.permissions.length === 0 && grantee.inheritedPermissions.length !== 0) {
        disableWithTooltip(remove, types_1.isGranularGranteeUser(grantee)
            ? locales_1.granularPermissionMessageTooltips.cannotRemoveFromParentForUser.id
            : locales_1.granularPermissionMessageTooltips.cannotRemoveFromParentForGroup.id);
    }
    // disable all permissions change if all assignment options are disabled and also the Remove option is disabled
    if (change.enabled &&
        !remove.enabled &&
        permissionTypeItems.every(function (item) { return !item.enabled || item.hidden || item.id === granteeEffectivePermission; })) {
        disableWithTooltip(change, types_1.isGranularGranteeUser(grantee)
            ? locales_1.granularPermissionMessageTooltips.noChangeAvailableForUser.id
            : locales_1.granularPermissionMessageTooltips.noChangeAvailableForGroup.id);
    }
    return {
        remove: remove,
        assign: {
            items: permissionTypeItems,
            effective: granteeEffectivePermission,
        },
        change: change,
    };
};
//# sourceMappingURL=permissionsLogic.js.map